import { parentCreateStudentRequest, parentStudentsListRequest } from '../api/parentStudents.api';

const toRouteId = (value = '') =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const toGradeNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;

  const match = value.toString().match(/\d+/);
  return match ? Number(match[0]) : null;
};

const getStudentClassesList = (student) =>
  student?.student_classes || student?.classes?.student_classes || student?.classes_list || student?.classes || [];

const getHighestGradeLabel = (student) => {
  const classes = getStudentClassesList(student);
  if (!Array.isArray(classes) || classes.length === 0) return 'Grade --';

  const highest = classes.reduce((max, item) => {
    const candidates = [item?.grade, item?.grade_name, item?.grade_title, item?.grade_label];
    const gradeNumber = candidates.map(toGradeNumber).find((value) => value !== null);
    return gradeNumber !== null && gradeNumber > max ? gradeNumber : max;
  }, -1);

  return highest >= 0 ? `Grade ${highest}` : 'Grade --';
};

const normalizeStudent = (student) => ({
  ...student,
  id: student?.id ?? student?.student_id ?? student?.uuid ?? student?.pk ?? null,
  routeId:
    student?.id ?? student?.student_id ?? student?.uuid ?? student?.pk ?? toRouteId(student?.name || student?.full_name || student?.fullname || `${student?.first_name || ''} ${student?.last_name || ''}`),
  firstName: student?.firstName || student?.first_name || student?.given_name || '',
  lastName: student?.lastName || student?.last_name || student?.surname || '',
  displayName:
    [student?.firstName || student?.first_name || student?.given_name, student?.lastName || student?.last_name || student?.surname]
      .filter(Boolean)
      .join(' ')
      .trim() ||
    student?.name ||
    student?.full_name ||
    student?.fullname ||
    '',
  classes: {
    activeCount: student?.classes?.active_count ?? student?.classes?.activeCount ?? 0,
    pendingCount: student?.classes?.not_active_count ?? student?.classes?.pendingCount ?? 0,
    raw: student?.classes || null,
  },
  gradeLabel: getHighestGradeLabel(student),
});

const extractStudents = (payload) => {
  const students = Array.isArray(payload) ? payload : payload?.students || payload?.data || [];

  return students.map(normalizeStudent);
};

export const getParentStudents = async () => {
  const res = await parentStudentsListRequest();
  return extractStudents(res.data);
};

export const createParentStudent = async (data) => {
  const res = await parentCreateStudentRequest(data);
  return res.data;
};
